import {
  ActivationStatus,
  AddressType,
  AppliedTo,
  ApportionmentType,
  AttemptType,
  AttemptStatus,
  BillingMode,
  CardBrand,
  ContactType,
  ContractStatus,
  DataOrigin,
  Gender,
  InstallmentStatus,
  InstallmentType,
  PaymentFrequency,
  PaymentMethod,
  PolicyStatus,
  ServiceActivationStatus,
  TicketStatus,
  TransactionStatus,
  RefundStatus,
  RefundStatusOperation,
  RefundGroupStatus,
  RefundType,
  BrcodeType,
  ClientAccountRefund,
  PaymentDestination,
  ApplicationType,
  TenantFileType,
  Week,
  Month,
  TrackingEnum,
  TypeIdEnum,
  ContractReasonCancellation,
  ActionsInstallmentStatus,
  NotifyType,
  WebhookEventStatus,
} from '@/app/shared/enums';
import {
  CompanyModule,
  ContractModule,
  DataModule,
  LoadingModule,
  PolicyModule,
  TicketModule,
  UserModule,
  CampaignModule,
  NotifyModule,
} from '@/app/shared/modules';
import {
  CompanyService,
  ContractService,
  CampaignService,
  DataService,
  PolicyService,
  TicketService,
  UserService,
  NotifyService,
  RefundService,
} from '@/app/shared/services';
import {
  EnumDescriptions,
  GenerateInteractions,
  Rules,
  enumHelper,
  util,
} from '@/app/shared/utils';
import { accountTypes, banks, paymentMethodRefunds } from '@/environments';
import _ from 'lodash';
import moment from 'moment';
import { Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';

const refsService = {
  enums: {
    AppliedTo,
    CardBrand,
    ActivationStatus,
    ApportionmentType,
    AttemptType,
    AttemptStatus,
    BillingMode,
    ContractStatus,
    InstallmentStatus,
    InstallmentType,
    PaymentFrequency,
    PaymentMethod,
    TransactionStatus,
    AddressType,
    ContactType,
    Gender,
    TicketStatus,
    PolicyStatus,
    DataOrigin,
    ServiceActivationStatus,
    RefundStatus,
    RefundStatusOperation,
    RefundGroupStatus,
    RefundType,
    BrcodeType,
    ClientAccountRefund,
    PaymentDestination,
    ApplicationType,
    TenantFileType,
    Week,
    Month,
    TrackingEnum,
    TypeIdEnum,
    ContractReasonCancellation,
    ActionsInstallmentStatus,
    NotifyType,
    WebhookEventStatus,
  },

  modules: {
    loading: getModule(LoadingModule),
    contract: getModule(ContractModule),
    company: getModule(CompanyModule),
    data: getModule(DataModule),
    policy: getModule(PolicyModule),
    ticket: getModule(TicketModule),
    user: getModule(UserModule),
    campaign: getModule(CampaignModule),
    notify: getModule(NotifyModule),
  },

  services: {
    contract: new ContractService(),
    company: new CompanyService(),
    data: new DataService(),
    policy: new PolicyService(),
    ticket: new TicketService(),
    campaign: new CampaignService(),
    user: new UserService(),
    notify: new NotifyService(),
    refund: new RefundService(),
  },

  static: {
    enumDescriptions: EnumDescriptions,
    rules: Rules,
    accountTypes,
    banks,
    paymentMethodRefunds,
  },

  generateInteractions: new GenerateInteractions(),
  eventBus: new Vue(),
  enumHelper,
  util,
  moment,
  _,
};

export { refsService };
